import { useAppTranslation } from '@/infrastructure/hooks/useAppTranslation';
import { StaticProfileConfig } from '@lemontaps/lib/types/api';
import { Stack, Typography } from '@mui/material';
import Policies from './components/Policies';
import CookieSettings from './components/CookieSettings';

interface Props {
  config: StaticProfileConfig['footer'];
  supportedLangs: string[];
  renderCookieSettings?: boolean; //defaults to false
}

export default function Footer({ config, supportedLangs, renderCookieSettings = false }: Props) {
  const { t, Translation } = useAppTranslation();
  return (
    <Stack direction='column' spacing={2} pt={4}>
      <Policies imprint={config.imprint} privacyPolicy={config.privacyPolicy} />
      {config.copyright && (
        <Typography variant='body2' color='secondary'>
          {config.copyright} <br />
          {t('allRightsReservedPublic')}
        </Typography>
      )}
      {supportedLangs.length > 1 && (
        <Translation languages={supportedLangs} textAlign='center' justifyContent='center' py={4} />
      )}
      {renderCookieSettings && <CookieSettings />}
    </Stack>
  );
}
